









import VueOptions from '@utils/VueOptions'
import FormFieldRadioButton from '@ui/FormBuilder/FormFields/FormFieldRadioButton'

settings =
  name: 'FormFieldRating'

  vue:
    props: ['value', 'errors']

    components: {
      FormFieldRadioButton,
    }

    data: ->
      rating: @value

    computed:
      optionsForRadioButton: ->
        options = []
        options.push { value: 1, html: '1<br><small>Not likely</small>' }
        options.push { value: n, label: n } for n in [2..9]
        options.push { value: 10, html: '10<br><small>Very likely</small>' }
        options

    methods:
      hiInputChange: (value) ->
        @rating = value
        @$emit 'input', value
        @$emit 'change', value

    watch:
      value: (v) ->
        @rating = v

export default VueOptions.vue settings
